export const SELECT_ALL = 'selectAll';
export const CURRENTLY_ASSIGNED = 'currentlyAssigned';
export const CLEAR_SELECTION = 'clearSelection';

// Accuracy constants
export const ACCURACY0TO50 = 'accuracy0to50';
export const ACCURACY51TO84 = 'accuracy51to84';
export const ACCURACY85TO100 = 'accuracy85to100';

// Progress constants
export const COMPLETED1TO20 = 'completed1to20';
export const COMPLETED21TO40 = 'completed21to40';
export const COMPLETED41TO60 = 'completed41to60';
export const COMPLETED61TO80 = 'completed61to80';
export const COMPLETED81TO100 = 'completed81to100';
